import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthorizationBase } from 'src/app/shared/libraries/authorize-base';
import { RecurringInvoiceSuspension } from "../../models/invoice.model";
import { AlertService } from "../../../core/alert.service";
import { RecurringInvoiceService } from "../../services/recurring-invoice.service";

@Component({
  selector: 'app-subscription-suspension-form',
  templateUrl: './subscription-suspension-form.component.html',
  styleUrls: ['./subscription-suspension-form.component.scss']
})
export class RecurringInvoiceSuspensionFormComponent extends AuthorizationBase implements OnInit {
  @Input() subscriptionId: number;
  @Input() recurringInvoiceId: number;
  @Input() viewOnly: boolean;
  @Input() source: string = 'subscription';
  model: RecurringInvoiceSuspension;
  minDate:Date = new Date();
  user: any;
  saving: boolean;
  busy: boolean;

  constructor(private modalRef: NgbActiveModal,
    private alert: AlertService,
    private recurringInvoiceService: RecurringInvoiceService) {

      super();

    this.user = this.getCurrentLoginUser();

    this.model = new RecurringInvoiceSuspension();
    this.model.SuspendedDate = new Date();
    this.model.SuspensionEndDate = new Date();
    this.model.UpdatedBy = this.user.UserId;

  }

  ngOnInit() {
    this.model.RecurringInvoiceId = this.recurringInvoiceId;

    this.busy = true;
    this.loadRecurringInvoiceSuspension();
  }

  loadRecurringInvoiceSuspension() {
    this.recurringInvoiceService.getSuspensionsByRecurringId(this.recurringInvoiceId)
      .subscribe((res:RecurringInvoiceSuspension[])=>{
        this.busy = false;
        if (res && res.length && this.viewOnly) {
          const result: any = res[res.length-1];
          this.model.Id = result.id;
          this.model.RecurringInvoiceId = result.recurringInvoiceId;
          this.model.Reason = result.reason;
          this.model.CreatedByUserName = result.createdByUserName;
          this.model.CreatedDateTZBased = result.createdDateTZBased;
          this.model.CreatedDate = result.createdDate;
          this.model.UpdatedDate = result.updatedDate;
          this.model.UpdatedByUserName = result.updatedByUserName;
          this.model.UpdatedDateTZBased = result.updatedDateTZBased;
          this.model.SuspendedDate = result.suspendedDate;
          this.model.SuspensionEndDate = result.suspensionEndDate;
        }
      });
  }

  isFormvalid(){
    if(!this.model.SuspensionEndDate || !this.model.Reason)
      return false;

    return true;
  }

  save(){
    this.saving = true;
    this.recurringInvoiceService.suspend(this.model)
      .subscribe((res:any)=>{
        if(res){
          this.saving = false;
          this.alert.alertInfo({ title: 'Success', text : 'Invoice has been successfully suspended' });
          this.close(res);
        }
      }, (error: any)=>{
        this.alert.alertError({ title: 'Error', text : 'Failed to save request.' });
      }, ()=>{
        this.saving = false;
      });
  }

  close(data?: any) {
    this.modalRef.close(data);
  }

}
